import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import SweetAlert from 'react-bootstrap-sweetalert';

import { constants } from '../../config';
import { ScreenStore } from '../../stores/ScreenStore';
import { IncrementalCheckoutSummary } from '../../common/incremental-checkout-summary';
import { SecondaryButton } from '../../common/secondary-button';
import { OPTION_TYPES } from '../../models/ShippingOption';
import { PhoneSelection } from './phone-selection';
import { ShippingSection } from './shipping-section';
import { ShippingSummary } from './shipping-summary';
import styles from './ShippingOptions.css';
import { CheckoutStore } from '../../stores/CheckoutStore';
import * as modalGlobal from '../../common/global/modal';
import { InfoModal } from '../../common/info-modal';
import { ConfigParametersStore } from '../../stores/ConfigParametersStore';

const IPropTypes = {
  onSubmit: PropTypes.func,
};

const defaultProps = {
  onSubmit: () => {},
};

class ShippingOptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstPhone: null,
      secondPhone: null,
      selectedOption: null,
      selectedTimeSlot: null,
      selectedAgency: null,
      selectShippingAgency: false,
    };

    this._onOptionSelection = this._onOptionSelection.bind(this);
    this._onPhoneSelection = this._onPhoneSelection.bind(this);
    this._onSubmit = this._onSubmit.bind(this);
    this._onPreSubmit = this._onPreSubmit.bind(this);
    this._needShowModal = this._needShowModal.bind(this);
    this._extraMessage = this._extraMessage.bind(this);
  }

  _onPhoneSelection(firstPhone, secondPhone) {
    this.setState({
      firstPhone,
      secondPhone,
    });
  }

  _onOptionSelection(option, selectedTimeSlot, selectedAgency) {
    this.setState({
      selectedOption: option,
      selectedTimeSlot,
      selectedAgency,
    });
  }

  _submitReady() {
    let optionValid = false;
    if (!this.state.selectedOption) {
      optionValid = false;
    } else if (this.state.selectedOption.optionType === OPTION_TYPES.SPECIAL) {
      optionValid = this.state.selectedTimeSlot;
    } else if (this.state.selectedOption.optionType === OPTION_TYPES.AGENCY) {
      optionValid = this.state.selectedTimeSlot && this.state.selectedAgency;
    } else {
      optionValid = true;
    }
    if (CheckoutStore.pickupChosen && this.state.firstPhone) {
      return true;
    }
    return this.state.firstPhone && optionValid;
  }

  _needShowModal() {
    return this.state.selectedOption &&
        (this.state.selectedOption.optionType === OPTION_TYPES.SIMPLE
            || this.state.selectedOption.optionType === OPTION_TYPES.SPECIAL);
  }

  _extraMessage() {
    let message = '';
    if (CheckoutStore.productWithCondition) {
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const key in CheckoutStore.productWithCondition) {
        message += `<li>${CheckoutStore.productWithCondition[key].replace('[articulo]', key)}</li>`;
      }
    }
    return message;
  }

  _onPreSubmit() {
    modalGlobal.hideModal();
    if (!CheckoutStore.pickupChosen &&
        this.state.selectedOption.optionType === OPTION_TYPES.AGENCY) {
      this.setState({
        selectShippingAgency: true,
      });
    } else {
      this._onSubmit();
    }
  }

  _onSubmit() {
    this.props.onSubmit(
      this.state.firstPhone,
      this.state.secondPhone,
      this.state.selectedOption,
      this.state.selectedTimeSlot,
      this.state.selectedAgency,
    );
  }

  render() {
    const title = (
      <div><p className={styles.titlePModal}>{`CG despachará mi pedido por $${this.state.selectedOption && this.state.selectedOption.price} (hasta 3 bultos)`}</p>
        <h4 className={styles.titleH5Modal}>La agencia cobrará además el flete MVD-Destino</h4>
      </div>
    );
    const hasArticleInPresale = CheckoutStore.checkoutCart
      .map(item => item.product.id)
      .some(item => ConfigParametersStore.isValueInFeatureFlagData('product_next_deliveries', item));
    return (
      <div className={styles.container}>
        <h1 className={styles.title}>
          {!CheckoutStore.pickupChosen ? 'Opciones de envío' : 'Télefonos de contacto'}
        </h1>
        <div className={styles.mainContent}>
          <div className={styles.optionSection}>
            {!CheckoutStore.pickupChosen &&
              <ShippingSection onSelection={this._onOptionSelection} />
            }
            {!CheckoutStore.pickupChosen &&
              <div className={styles.warning}>
                En edificios, siempre y cuando el espacio sea amplio para hacerlo con facilidad,
                subimos la mercadería hasta el 3er piso.
              </div>
            }
            {!CheckoutStore.pickupChosen &&
              <ShippingSummary
                agencyId={this.state.selectedAgency ? this.state.selectedAgency.id : null}
                className={styles.shippingSummary}
                option={this.state.selectedOption}
              />
            }
            <PhoneSelection
              requestOnePhone={CheckoutStore.pickupChosen}
              onPhoneSelection={this._onPhoneSelection}
            />
            <div className={styles.buttonContainer}>
              <InfoModal
                showModal={this._needShowModal()}
                id={!hasArticleInPresale ? 'instalacion-condiciones-entrega' : 'instalacion-condiciones-entrega-preventa'}
                type="button-with-action"
                extraMessage={this._extraMessage()}
                actionConfirm={this._onPreSubmit}
              >
                <SecondaryButton
                  className={styles.button}
                  disabled={!this._submitReady()}
                >
                  Continuar
                </SecondaryButton>
              </InfoModal>
            </div>
          </div>
          {
            ScreenStore.screenWidth > constants.breakpoints.smallMaxWidth &&
            <div className={styles.summarySection}>
              <IncrementalCheckoutSummary />
            </div>
          }
        </div>
        {
          this.state.selectShippingAgency &&
          <SweetAlert
            title={title}
            showCancel
            confirmBtnText="Sí, lo conozco"
            confirmBtnCssClass={`${styles.btnAccept} ${styles.btn}`}
            cancelBtnText="No, voy a averiguar"
            cancelBtnCssClass={`${styles.btnNoAccept} ${styles.btn}`}
            onConfirm={this._onSubmit}
            onCancel={() => this.setState({ selectShippingAgency: false })}
            closeOnClickOutside={false}
            style={{
              width: '100%',
              left: 0,
              right: 0,
              maxWidth: '500px',
              margin: '0 auto',
              top: '30%',
            }}
          >
            <h4>
              ¿Conozco y acepto el costo de la Agencia
              MVD-Destino y entiendo que es ajeno a Carlos Gutiérrez?
            </h4>
          </SweetAlert>
        }
      </div>
    );
  }
}

ShippingOptions.propTypes = IPropTypes;
ShippingOptions.defaultProps = defaultProps;

const ObservedShippingOptions = observer(ShippingOptions);

export { ObservedShippingOptions as ShippingOptions };



// WEBPACK FOOTER //
// ./src/pages/shipping-options/ShippingOptions.jsx